import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  InputAdornment,
  MenuItem,
  Stack,
  TextField,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { PersonAdd } from "@mui/icons-material";
import toast from "react-hot-toast";
import { handleSubmit } from "./handleSubmit";
import {
  setUserData as reduxSetUserData,
  initialState as reduxInitialStateUser,
} from "../../../redux/slice/userSlice";
import { handleError } from "../../../utils/handleError";
import { uploadImageAux } from "../../UploadImage/uploadImageAux";
import { formatDateForInput } from "./formatData";
import { useNavigate } from "react-router-dom";
import { handleSubmitProvider } from "./handleSubmitProvider";
import { getProviderById } from "../../../services/rest/servicesProvider/servicesProvider";
import { getUserById } from "../../../services/rest/users/userService";

const FormInfoUser = ({ setLoading }) => {
  const {
    _id,
    firstName,
    lastName,
    nickName,
    rol,
    address,
    dateBirth,
    email,
    emailVerified,
    gender,
    phoneNumber,
    phoneVerified,
    urlImg,
    status,
  } = useSelector((state) => state.userReducer);
  const [userData, setUserData] = useState({
    firstName,
    lastName,
    nickName,
    rol,
    city: address?.city ?? "",
    street: address?.street ?? "",
    state: address?.state ?? "",
    postalCode: address?.postalCode ?? 0,
    dateBirth: formatDateForInput(dateBirth),
    email,
    emailVerified,
    gender: gender ?? "",
    phoneNumber: phoneNumber.replace(/^\+52/, ""),
    phoneVerified,
    urlImg,
  });
  const [errors, setErrors] = useState({});
  const genderList = [
    {
      value: "Masculino",
      label: "Masculino",
    },
    {
      value: "Femenino",
      label: "Femenino",
    },
    {
      value: "Otro",
      label: "Otro",
    },
  ];
  const { membershipStatus } = useSelector((state) => state.userReducer);
  const { userType } = useSelector((state) => state.userReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleChangeUserData = (e) => {
    const { name, value } = e.target;

    // console.log("OnChange:", name, value);
    if (name === "dateBirth") {
      setUserData({ ...userData, [name]: value });
      return;
    }
    setUserData({ ...userData, [name]: value });
  };
  const sendData = async () => {
    try {
      if (status === "inactive") {
        toast.error(
          `Tu cuenta no esta completa. \n ${status === "inactive" && "Verifica tu correo."}`
        );
        return;
      }
      const statusAccount = status;
      let response;
      let responseUser;
      setLoading(true);
      // console.log("Tipo de usuario:", userType);

      if (userType === "user") {
        // console.log("Es un tipo de usuario user", userType);

        response = await handleSubmit({
          setErrors,
          userData,
          _id,
          status,
        });
        // console.log("Respuesta de handleSubmit", response);
      } else {
        // console.log("Es un tipo de usuario provider", userType);
        response = await handleSubmitProvider({
          setErrors,
          _id,
          status,
          userData,
        });
      }
      // if (!response?.data) {
      //   setLoading(false);
      //   return;
      // }
      if (userType === "user") {
        responseUser = await getUserById(_id);
        // console.log(
        //   "Respuesta de get user by id en userType user",
        //   responseUser
        // );
      } else {
        responseUser = await getProviderById(_id);
        responseUser.rol = responseUser?.role;
        responseUser.userType = "provider";
        // console.log(
        //   "Respuesta de get user by id en userType provider",
        //   responseUser
        // );
      }
      // console.log("Status de cuenta antes de actualizar", statusAccount);

      if (statusAccount === "pending") {
        // console.log("navegar a verificar");
        navigate("/verifyCode");
      }
      // console.log("Satatus de cuenta antes de actualizar", status);

      dispatch(reduxSetUserData({ ...reduxInitialStateUser, ...responseUser }));
      // console.log(
      //   "Satatus de cuenta despues de actualizar, se hace envio a codigo sms si es pending",
      //   status
      // );

      setLoading(false);
      toast.success("Datos actualizados correctamente");
    } catch (error) {
      setLoading(false);
      const { message } = handleError(error);
      toast.error(
        `No se puede ${status === "pending" ? "completar" : "actualizar"} su información.\n ${message}`
      );
    }
  };
  return (
    <Stack
      direction={{ xs: "column", md: "row", sm: "row" }}
      spacing={4}
      sx={{ justifyContent: "space-around" }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 5,
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {userData?.urlImg && (
            <img
              src={userData?.urlImg}
              alt="Preview"
              style={{ maxWidth: "200px", marginTop: "10px" }}
            />
          )}
          <Button
            onClick={() => uploadImageAux({ setUserData, userData })}
            variant="contained"
            sx={{ backgroundColor: "#e7ef7d" }}
          >
            Seleccionar imagen
          </Button>
        </Box>
        <Stack direction="row" spacing={4}>
          <Stack direction="column" spacing={4}>
            <FormControl>
              {/* <InputLabel htmlFor="component-outlined">Nombre</InputLabel> */}
              <TextField
                name="firstName"
                defaultValue={userData?.firstName ?? ""}
                label={"Nombre"}
                onChange={handleChangeUserData}
                error={Boolean(errors?.firstName)}
                helperText={errors?.firstName}
              />
            </FormControl>
            <FormControl>
              {/* <InputLabel htmlFor="component-outlined">
                Fecha de Nacimiento
              </InputLabel> */}
              <TextField
                label="Fecha del nacimiento"
                name="dateBirth"
                type="date"
                variant="outlined"
                value={
                  userData?.dateBirth
                    ? formatDateForInput(userData.dateBirth)
                    : new Date().toISOString().split("T")[0]
                }
                onChange={handleChangeUserData}
                fullWidth
                required
                sx={{ mb: 2 }}
                InputLabelProps={{
                  shrink: true,
                }}
                error={Boolean(errors?.dateBirth)}
                helperText={errors?.dateBirth}
              />
            </FormControl>
            <FormControl>
              <TextField
                name="nickName"
                defaultValue={userData?.nickName ?? ""}
                label={"Nick Name"}
                onChange={handleChangeUserData}
                disabled
              />
            </FormControl>
          </Stack>
          <Stack direction="column" spacing={4}>
            <FormControl>
              <TextField
                defaultValue={userData?.lastName ?? ""}
                name="lastName"
                label={"Apellidos"}
                onChange={handleChangeUserData}
                error={Boolean(errors?.lastName)}
                helperText={errors?.lastName}
              />
            </FormControl>
            <FormControl>
              <TextField
                id="outlined-select-currency"
                select
                label="Genero"
                name="gender"
                defaultValue={userData?.gender || "Femenino"}
                error={Boolean(errors?.gender)}
                helperText={errors?.gender}
                onChange={handleChangeUserData}
              >
                {genderList.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>
          </Stack>
        </Stack>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 5,
        }}
      >
        <Stack direction="row" spacing={4}>
          <Stack direction="column" spacing={4}>
            <FormControl>
              <TextField
                //   id="component-outlined"
                name="street"
                defaultValue={userData?.street ?? ""}
                label={"Calle"}
                onChange={handleChangeUserData}
                error={Boolean(errors?.street)}
                helperText={errors?.street}
              />
            </FormControl>
            <FormControl>
              <TextField
                name="city"
                defaultValue={userData?.city ?? ""}
                label={"Cuidad"}
                onChange={handleChangeUserData}
                error={Boolean(errors?.city)}
                helperText={errors?.city}
              />
            </FormControl>
            <FormControl>
              <TextField
                label="Telefono"
                name="phoneNumber"
                defaultValue={userData?.phoneNumber}
                sx={{ m: 1, width: "25ch" }}
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">+52</InputAdornment>
                    ),
                  },
                }}
                onChange={handleChangeUserData}
                error={Boolean(errors?.phoneNumber)}
                helperText={errors?.phoneNumber}
                disabled={status === "active"}
              />
            </FormControl>
          </Stack>
          <Stack direction="column" spacing={4}>
            <FormControl>
              <TextField
                name="state"
                defaultValue={userData?.state ?? ""}
                label={"Estado"}
                onChange={handleChangeUserData}
                error={Boolean(errors?.state)}
                helperText={errors?.state}
              />
            </FormControl>
            <FormControl>
              <TextField
                name="postalCode"
                defaultValue={userData?.postalCode ?? ""}
                label={"Codigo postal"}
                onChange={handleChangeUserData}
                error={Boolean(errors?.postalCode)}
                helperText={errors?.postalCode}
              />
            </FormControl>
            <FormControl>
              <TextField
                name="email"
                defaultValue={userData?.email ?? ""}
                label={"Email"}
                disabled
              />
            </FormControl>
          </Stack>
        </Stack>
        <Button
          variant="contained"
          sx={{ backgroundColor: "#e7ef7d" }}
          startIcon={<PersonAdd />}
          onClick={sendData}
        >
          Guardar
        </Button>
      </Box>
    </Stack>
  );
};

export default FormInfoUser;
